import type { SearchResult, Suggestion } from '../types'

export const MOCK_RESULTS: SearchResult[] = [
  {
    id: '1',
    title: 'Getting Started',
    summary:
      'Learn how to install and configure the SDK in under five minutes. Covers authentication, your first API call, and common setup patterns.',
    url: 'http://localhost:3000/docs/getting-started.html',
    section: 'installation',
  },
  {
    id: '2',
    title: 'API Reference',
    summary:
      'Complete reference for all API endpoints, request shapes, response types, and error codes.',
    url: 'http://localhost:3000/docs/api-reference.html',
  },
  {
    id: '3',
    title: 'Pricing',
    summary:
      'Free tier supports up to 1,000 searches per month. Pro plan unlocks AI search, white-labelling, and custom shortcuts.',
    url: 'http://localhost:3000/pricing.html',
  },
  {
    id: '4',
    title: 'About',
    summary:
      'Spotlight is built by a small team focused on AI-native navigation. We believe every website deserves instant search.',
    url: 'http://localhost:3000/about.html',
  },
]

export const MOCK_SUGGESTIONS: Suggestion[] = [
  { id: 's1', label: 'How do I get started?' },
  { id: 's2', label: 'What is included in the free plan?' },
  { id: 's3', label: 'How do I add the widget to my site?' },
]

export function searchMock(query: string): SearchResult[] {
  const q = query.toLowerCase()
  return MOCK_RESULTS.filter(
    (r) => r.title.toLowerCase().includes(q) || r.summary.toLowerCase().includes(q),
  )
}
